// assets
import { IconDeviceMobile, IconMail, IconSticker } from '@tabler/icons-react';
import { AUTHORITIES } from 'constants/authorities';

// constant
const icons = { AppSettingsAlt: IconDeviceMobile, Mail: IconMail, Sticker: IconSticker };

// ==============================|| MANAGE MENU ITEMS ||============================== //

const manage = {
    id: 'manage',
    title: 'Manage',
    type: 'group',
    children: [
        {
            id: 'forceUpdate',
            title: 'Force Update',
            type: 'item',
            url: '/manage/forceUpdate',
            icon: icons.AppSettingsAlt,
            authority: 'INFRA_VIEW'
        },
        {
            id: 'mail',
            title: 'Mail',
            type: 'item',
            url: '/manage/mail',
            icon: icons.Mail,
            authority: 'MAIL_SEND'
        },
        {
            id: 'sticker',
            title: 'Sticker',
            type: 'item',
            url: '/manage/sticker',
            icon: icons.Sticker,
            authority: AUTHORITIES.STICKER_EDIT
        }
    ]
};

export default manage;
